import { IContactRespSchema, MCustomSelectProps } from '@monetize/types/app';
import { forwardRef, useEffect, useState } from 'react';
import { CONTACTS } from '../../constants';
import { BlankText } from '../Monetize/BlankText';
import { MainSearchInput } from '../Monetize/MCustomSelect/components/MainSearchInput';
import { MCustomSelect } from '../Monetize/MCustomSelect/MCustomSelect';
import { contactSelectRenderItem } from './ContactSelect';

interface ContactSelectWithDataProps extends MCustomSelectProps {
  isDisabled?: boolean;
  contacts: IContactRespSchema[];
  loading?: boolean;
  onChange: (contactId: string) => void;
  onNewContact?: () => void;
  canCreateContact?: boolean;
}

export const ContactSelectWithData = forwardRef(
  (
    {
      isDisabled,
      contacts,
      loading,
      onChange,
      onNewContact,
      canCreateContact = false,
      value,
      ...rest
    }: ContactSelectWithDataProps,
    ref,
  ) => {
    const [query, setQuery] = useState('');
    const [iContacts, setIContacts] = useState(contacts);
    const onChangeQuery = (queryVal: string): void => {
      if (queryVal !== query) {
        setQuery(queryVal);
      }
    };

    useEffect(() => {
      if (query) {
        setIContacts(
          contacts.filter(
            ({ fullName, email }) =>
              fullName?.toLowerCase().includes(query.toLowerCase()) ||
              email?.toLowerCase().includes(query.toLowerCase()),
          ),
        );
      } else {
        setIContacts(contacts);
      }
    }, [contacts, query]);

    if (isDisabled && !value) {
      return <BlankText />;
    }

    return (
      <MCustomSelect
        name="contacts"
        loading={loading}
        items={iContacts}
        itemTitle="fullName"
        itemValue="id"
        onChange={(ev: any) => onChange(ev as string)}
        useMainInputAsSearchInput
        MainInputComponent={MainSearchInput}
        useHighlightedItemList
        showItemDivider
        inputProps={{
          autoComplete: 'off',
        }}
        useExternalQuery
        externalQuery={query}
        onChangeQuery={onChangeQuery}
        skipFilter={true}
        prependItems={
          canCreateContact && onNewContact
            ? [
                {
                  item: CONTACTS.NEW_CONTACT,
                  isAction: true,
                  hasDivider: true,
                  onClick: ({ onClose }) => {
                    onClose && onClose();
                    onNewContact();
                  },
                },
              ]
            : []
        }
        renderItemContent={contactSelectRenderItem}
        isDisabled={isDisabled}
        value={value}
        {...rest}
      />
    );
  },
);
